import React from 'react';
import { Link } from 'react-router-dom';
import Sidebar from '../mendepartmentdetails/Sidebar';
import SubDeptImage from '../../../assets/image/department/senior-couple-training-together_23-2148730145.jpg';

function SocialRecreationalSeniors() {
  return (
    <section className="department-details-section">
      <div className="container">
        <div className="row">

          {/* Sidebar */}
          <div className="col-12 col-lg-4 col-xl-4">
            <Sidebar />
          </div>

          {/* Main Content */}
          <div className="col-lg-8">
            <div className="department-details-imgbox">
              <img src={SubDeptImage} className="img-fluid" alt="Social and Recreational Activities for Seniors" />
            </div>

            <div className="department-details-content-box">
              <h4 className="department-details-title">Social and Recreational Activities for Seniors</h4>
              <p>
                This sub-department provides a variety of activities and programs designed to foster social engagement and promote active lifestyles among seniors.<br />
                Programs include group outings, recreational classes, and hobby-based workshops to enhance community connections and well-being.<br /><br />
                We aim to enrich the lives of seniors by offering opportunities for meaningful social interactions and enjoyable activities.
              </p>
            </div>

            <div className="department-details-benefits-box">
              <h3>Key Services</h3>
              <ul className="list-unstyled list-style">
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Group Outings and Social Events</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Recreational and Fitness Classes</h5>
                </li>
                <li>
                  <i className="fa-solid fa-circle-arrow-right" />
                  <h5>Hobby and Craft Workshops</h5>
                </li>
              </ul>
            </div>

            <div className="department-details-policy-box">
              <h4>Our Commitment:</h4>
              <p>
                We are dedicated to creating engaging opportunities for seniors to stay active, build relationships, and enjoy fulfilling social experiences.
              </p>
            </div>
            <div>
              <Link to="/department/senior-services">
                <i className="fa-solid fa-circle-arrow-left" style={{ marginRight: '5px' }} />
                Go Back
              </Link>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}

export default SocialRecreationalSeniors;
